export * from './lib/landing-page.module';
